import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { MapPin, Menu, X } from "lucide-react";
import { toast } from "sonner";
import { HEADER_NAV, CONTACT } from "@/data/site";

const soon = () =>
    toast("Consultation scheduling is by phone or email for now — details are at the bottom of the page.");

export const Header = () => {
    const [open, setOpen] = useState(false);
    return (
        <header data-testid="site-header" className="sticky top-0 z-50 border-b border-[#0B1F3A]/10 bg-white/95 backdrop-blur">
            <div className="mx-auto flex max-w-7xl items-center justify-between gap-6 px-6 py-3">
                <Link to="/" data-testid="header-logo" className="flex items-center gap-3">
                    <img src="/assets/logo-mark.png" alt="Dr. Sergio Jaquez logo" className="h-12 w-auto sm:h-14" />
                    <span className="leading-tight">
                        <span className="block text-lg sm:text-xl font-extrabold tracking-wide text-[#0B1F3A]">
                            DR. SERGIO JAQUEZ
                        </span>
                        <span className="block text-[10px] sm:text-[11px] font-semibold tracking-[0.3em] text-[#C9A227]">
                            EDUCATION • COUNSELING • SUPPORT
                        </span>
                        <span className="mt-0.5 flex items-center gap-2 text-[9px] sm:text-[10px] font-semibold tracking-[0.35em] text-[#0B1F3A]/70">
                            <span className="h-px w-6 bg-[#C9A227]" />A PATH FORWARD
                            <span className="h-px w-6 bg-[#C9A227]" />
                        </span>
                    </span>
                </Link>

                <div className="hidden items-center gap-7 lg:flex">
                    <span data-testid="header-location" className="hidden items-center gap-1.5 text-sm font-medium text-[#0B1F3A]/80 xl:flex">
                        <MapPin className="h-4 w-4 text-[#C9A227]" />
                        {CONTACT.location}
                    </span>
                    <nav className="flex items-center gap-6" aria-label="Primary">
                        {HEADER_NAV.map((n) => (
                            <NavLink
                                key={n.to}
                                to={n.to}
                                data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                                className={({ isActive }) =>
                                    `text-sm font-semibold transition-colors duration-200 ${
                                        isActive
                                            ? "text-[#0B1F3A] underline decoration-[#C9A227] decoration-2 underline-offset-8"
                                            : "text-[#0B1F3A]/70 hover:text-[#0B1F3A]"
                                    }`
                                }
                            >
                                {n.label}
                            </NavLink>
                        ))}
                    </nav>
                    <button
                        type="button"
                        data-testid="header-schedule-btn"
                        onClick={soon}
                        className="rounded-lg bg-[#C9A227] px-5 py-2.5 text-sm font-semibold text-[#0B1F3A] shadow-[0_10px_25px_-12px_rgba(201,162,39,0.9)] transition-[transform,background-color] duration-300 hover:-translate-y-0.5 hover:bg-[#D4AF37]"
                    >
                        Schedule a Consultation
                    </button>
                </div>

                <button
                    type="button"
                    data-testid="mobile-menu-toggle"
                    aria-label="Toggle menu"
                    onClick={() => setOpen(!open)}
                    className="rounded-md p-2 text-[#0B1F3A] lg:hidden"
                >
                    {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
                </button>
            </div>

            {open && (
                <nav data-testid="mobile-menu" className="border-t border-[#0B1F3A]/10 bg-white px-6 py-4 lg:hidden" aria-label="Mobile">
                    {[...HEADER_NAV, { label: "Published Work", to: "/published-work" }, { label: "11th Steppers", to: "/11th-steppers" }]
                        .filter((v, i, a) => a.findIndex((x) => x.to === v.to) === i)
                        .map((n) => (
                            <NavLink
                                key={n.to}
                                to={n.to}
                                onClick={() => setOpen(false)}
                                data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                                className="block border-b border-[#0B1F3A]/5 py-3 text-sm font-semibold text-[#0B1F3A]/80"
                            >
                                {n.label}
                            </NavLink>
                        ))}
                    <button
                        type="button"
                        data-testid="mobile-schedule-btn"
                        onClick={soon}
                        className="mt-4 w-full rounded-lg bg-[#C9A227] px-5 py-3 text-sm font-semibold text-[#0B1F3A]"
                    >
                        Schedule a Consultation
                    </button>
                </nav>
            )}
        </header>
    );
};
